import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ConvexClientProvider from './ConvexClientProvider.jsx'
import './index.css'
import './styles/keyboard.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ConvexClientProvider>
      <App />
    </ConvexClientProvider>
  </React.StrictMode>,
)
